import { SubHeadline } from '~components/Typography';
import { annals } from '~features/annals/hooks';
import { UnsubscriptionFlowStages } from '~features/annals/names';
import { useTranslations } from '~i18n/hooks';
import { ReviewModal } from '~shared/ui/modals';

import { Policies } from '../Policies';
import { ReasonsForm } from '../ReasonsForm';

type Props = {
	onClose: () => void;
	onSubmit: (val: string) => void;
};

export const ReasonsModal = ({ onClose, onSubmit }: Props) => {
	const t = useTranslations('MySubscriptions');
	const trackCloseModal = annals.subscription.useClickElementCloseCancelSub(
		UnsubscriptionFlowStages.Survey
	);

	return (
		<ReviewModal
			open={true}
			onClose={() => {
				trackCloseModal();
				onClose();
			}}
			locked
			title={
				<SubHeadline size="M" align="left">
					{t('reasonsTitle')}
				</SubHeadline>
			}
			data-name="cancel-reasons-modal"
		>
			<ReasonsForm onSubmit={onSubmit} />

			<Policies screen={UnsubscriptionFlowStages.Survey} />
		</ReviewModal>
	);
};
